$(function() {
    var rules = {};

    $('.js-account-logins').validate({
        rules: rules,
        submitHandler: function(form) {
            $(form).find('[type="submit"]')
                .prop('disabled', true)
                .addClass('is-loading');

            window.assignRecaptchaResponseToForm(form).then(function() {
                form.submit();
            });
        }
    });

    $('.js-account-logins-modal').validate({
        rules: rules,
        submitHandler: function(form) {
            $(form).find('[type="submit"]')
                .prop('disabled', true)
                .addClass('is-loading');

            window.assignRecaptchaResponseToForm(form).then(function() {
                form.submit();
            });
        }
    });
});